export default {
  alternativeRock: Symbol('alternativeRock'),
  bigBeat: Symbol('bigBeat'),
  digitalHardcore: Symbol('digitalHardcore'),
  electro: Symbol('electro'),
  folk: Symbol('folk'),
  funk: Symbol('funk'),
  ukGarage: Symbol('ukGarage'),
  gothicRock: Symbol('gothicRock'),
  hardRock: Symbol('hardRock'),
  heavyMetal: Symbol('heavyMetal'),
  instrumental: Symbol('instrumental'),
  jazz: Symbol('jazz'),
  noise: Symbol('noise'),
  pops: Symbol('pops'),
  progressiveRock: Symbol('progressiveRock'),
  ska: Symbol('ska'),
  symphonicMetal: Symbol('symphonicMetal'),
}
